export const environment = {
  apiUrl: 'https://test.backend.tabletbizz.com',
  project_id: '',
  client_id: '',
  production: false,
};
